import React from 'react';
import { View, ViewProps, ViewStyle } from 'react-native';

import styles from './progress-bar-header.style';
import { useColors } from '../../hooks/lesson-player.context';

interface ProgressBarHeaderProps extends ViewProps {
  containerStyle?: ViewStyle;
  children: any;
}

export function ProgressBarHeader({
  style,
  containerStyle = {},
  children,
  ...props
}: ProgressBarHeaderProps) {
  const color = useColors();
  return (
    <View
      style={[
        styles.container,
        {
          borderColor: color.separatorOnBackground,
          backgroundColor: color.background,
        },
        containerStyle,
      ]}
      {...props}
    >
      <View style={[styles.innerContainer, style]}>{children}</View>
    </View>
  );
}
